export default __webpack_public_path__ + "static/media/sign-up-screenshoten.75e2307b.png";